module.exports = __webpack_public_path__ + "static/media/logo-login.135acea1.png";